import React from "react";

// types
import Rectangle from "./includes/Rectangle";
import Radio from "./includes/Radio";
import Dropdown from "./includes/Dropdown";

export default function VariationViewer(props) {
    // consts
    const {
        variantMainFields,
        availableCombinations,

        allowedVariantsValues,
        setAllowedVariantsValues,


        selectedOptionsByUser,
        setSelectedOptionsByUser,

        generateValues,

        selectedValue,
        setSelectedValue,

        setProductQuantity,
    } = props;

    return (
        <React.Fragment>
            {
                variantMainFields?.length ? variantMainFields.map((item, index) => {
                    // console.log("item ", item);
                    return (
                        <div key={item.id} className={`item st-fs-14 pb-3 level-${index}`}>
                            {item?.display_type === "rectangle_list" && (
                                <Rectangle
                                    dataLevel={index}
                                    availableCombinations={availableCombinations}

                                    allowedVariantsValues={allowedVariantsValues}
                                    setAllowedVariantsValues={setAllowedVariantsValues}

                                    data={item}

                                    selectedOptionsByUser={selectedOptionsByUser}
                                    setSelectedOptionsByUser={setSelectedOptionsByUser}
                                    generateValues={generateValues}

                                    selectedValue={selectedValue}
                                    setSelectedValue={setSelectedValue}

                                    setProductQuantity={setProductQuantity}
                                />
                            )}
                            {/* {item?.display_type === "radio_buttons" && (
                                <Radio
                                    data={item}
                                />
                            )}
                            {item?.display_type === "dropdown" && (
                                <Dropdown
                                    data={item}
                                />
                            )} */}
                        </div>
                    );
                }) : null
            }
        </React.Fragment>
    );
}
